import Environment from './Environment';
import Content from '../constants/Content';
import Logger from './Logger';

const getProductImageByColor = (media, color) => {
  try {
    if (!media || !media.length) {
      return 'https://s3.amazonaws.com/bitsy-product-images/default-product-image.png';
    }
    if (!color || color === 'NONE') return media[0].url;

    const colorIndex = media.map((mediaItem) => mediaItem.color).indexOf(color);

    if (colorIndex === -1) {
      return media[0].url;
    }

    return media[colorIndex].url;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getSubImage = (plan) => {
  try {
    if (plan.image) {
      return plan.image;
    }

    let imageUrl = '';
    if (Environment.store.includes('bump')) {
      imageUrl =
        'https://s3.amazonaws.com/bitsy-product-images/subscription-plan-images/bump/';
    } else {
      imageUrl =
        'https://s3.amazonaws.com/bitsy-product-images/subscription-plan-images/bitsy/';
    }

    if (plan.title.startsWith('Twelve Month')) {
      imageUrl += '12-month.png';
    } else if (plan.title.startsWith('Nine Month')) {
      imageUrl += '9-month.png';
    } else if (plan.title.startsWith('Six Month')) {
      imageUrl += '6-month.png';
    } else if (plan.title.startsWith('Three Month')) {
      imageUrl += '3-month.png';
    } else {
      imageUrl += 'monthly.png';
    }

    return imageUrl;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getProductUrlForSubscription = (subscription) => {
  try {
    const { plan } = subscription;
    const planTitleforUrl = plan.title.split(' ').join('-').toLowerCase();
    if (plan.months === 'INFINITY' && plan.title !== 'Month to Month') {
      return `${Environment.getSelfDomain}/products/${
        plan.productUrlPrefix || ''
      }${planTitleforUrl}-pregnancy-subscription-box`;
    }
    if (plan.title === 'Month to Month') {
      return `${Environment.getSelfDomain}/products/${
        plan.productUrlPrefix || ''
      }${planTitleforUrl}-bump`;
    }
    return `${Environment.getSelfDomain}/gift`;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getSubscriptionSku = (plan) => {
  const providerNameForSku = {
    bump: 'Bump Boxes ',
    bitsy: 'Bitsy ',
    wtebump: 'WTE Bump Boxes ',
    pnmbump: 'PNMag Bump Boxes ',
  };

  const providerName = providerNameForSku[Environment.store];

  return `${plan.title}${
    plan.months === 'INFINITY' ? ' ' : ' Prepaid '
  }${providerName}Subscription`;
};

const getDataForCart = (cart, includeViewedOn) => {
  try {
    const items = [];
    if (cart.subscription) {
      const { subscription } = cart;
      const imageUrl = getSubImage(subscription.plan);
      const productUrl = getProductUrlForSubscription(subscription);
      const ItemPrice = cart?.coupon
        ? subscription.plan.costWithCoupon
        : subscription.plan.actualCost;
      items.push({
        listrakSku: getSubscriptionSku(subscription.plan),
        listrakName: getSubscriptionSku(subscription.plan),
        SKU: `${subscription.plan.title} ${Content.names.shortName} Subscription`,
        ProductName: `${subscription.plan.title} ${Content.names.shortName} Subscription`,
        Quantity: 1,
        ItemPrice,
        listrakPrice: ItemPrice,
        RowTotal: cart?.coupon
          ? subscription.plan.costWithCoupon
          : subscription.plan.actualCost,
        ProductURL: productUrl,
        ImageURL: imageUrl,
      });
    }
    if (cart.productsAndDetails) {
      cart.productsAndDetails.forEach((productsAndDetailsItem) => {
        const { product } = productsAndDetailsItem;
        const mediaUrl = getProductImageByColor(
          product.media,
          productsAndDetailsItem.color,
        );
        let itemPrice = product.actualCost || 0;
        if (
          productsAndDetailsItem.amountToCharge != null &&
          Number.isFinite(Number(productsAndDetailsItem.amountToCharge))
        ) {
          itemPrice = productsAndDetailsItem.amountToCharge;
        } else if (productsAndDetailsItem.isBundledGWPProduct) {
          itemPrice = product?.ownPromoData?.bundledGWPCost || 0;
        } else if (productsAndDetailsItem.isAddedCouponProduct) {
          itemPrice = product?.ownPromoData?.cost || 0;
        }
        const viewedProductData = {
          SKU: product.sku || product.name,
          ProductName: product.name,
          listrakSku: product.sku || product.name,
          listrakName: product.name,
          Quantity: productsAndDetailsItem.quantity,
          ItemPrice: itemPrice,
          listrakPrice: itemPrice / productsAndDetailsItem.quantity,
          ProductURL: `${
            Environment.getSelfDomain
          }/products/${product.urlName?.toLowerCase()}`,
          ImageURL: mediaUrl,
          Color:
            productsAndDetailsItem.color !== 'NONE'
              ? productsAndDetailsItem.color
              : '',
          Variation:
            productsAndDetailsItem.variation !== 'NONE'
              ? productsAndDetailsItem.variation
              : '',
          ID: product._id,
          isBreastPump: productsAndDetailsItem.isBreastPump,
        };

        if (includeViewedOn) {
          viewedProductData.ViewedOn = new Date();
        }
        items.push(viewedProductData);
      });
    }
    return items;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

// removes plus signs, dashes, parantheses, and spaces
const formatPhoneNumberOnlyNumbers = (number) => {
  if (!number) {
    return '';
  }
  return number
    .replace(/[+]/g, '')
    .replace(/-/g, '')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/\s/g, '');
};

const getCountryAndAreaCodeAndNumber = (number) => {
  if (!number) {
    return {
      countryCode: '',
      areaCode: '',
      phoneNumber: '',
    };
  }
  const formattedNumber = formatPhoneNumberOnlyNumbers(number);
  if (formattedNumber.length === 11) {
    return {
      countryCode: formattedNumber.substr(0, 1),
      areaCode: formattedNumber.substr(1, 3),
      phoneNumber: formattedNumber.substr(4, 7),
    };
  }
  return {
    countryCode: '1',
    areaCode: formattedNumber.substr(0, 3),
    phoneNumber: formattedNumber.substr(3, 7),
  };
};

export default {
  getProductImageByColor,
  getSubImage,
  getDataForCart,
  getCountryAndAreaCodeAndNumber,
  getSubscriptionSku,
};
